// src/components/UploadLogs.js
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './UploadLogs.css';

function UploadLogs() {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const navigate = useNavigate();

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];

        if (!selectedFile) {
            return;
        }

        // Validate file type
        if (selectedFile.type !== 'application/json' && !selectedFile.name.endsWith('.json') &&
            selectedFile.type !== 'text/plain' && !selectedFile.name.endsWith('.text')) {
            setError('Please select a JSON file');
            setFile(null);
            return;
        }

        setFile(selectedFile);
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!file) {
            setError('Please select a file to upload');
            return;
        }

        setUploading(true);
        setError('');
        setSuccess('');

        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await api.post('/api/upload-logs', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            setSuccess(response.data.message);
            setFile(null);

            // Reset file input
            e.target.reset();

            // Redirect to call logs after 2 seconds
            setTimeout(() => {
                navigate('/call-logs');
            }, 2000);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to upload file');
            console.error(err);
        } finally {
            setUploading(false);
        }
    };

    const fileInputRef = useRef(null);

    return (
        <div className="upload-container">
            <h2>Upload Call Logs</h2>

            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            <div className="upload-form">
                <form onSubmit={handleSubmit}>

                    <div className="file-input-container">
                        <input
                            id="jsonFileInput"
                            type="file"
                            accept=".txt,json,application/json"
                            onChange={handleFileChange}
                            className="file-input"
                        />

                        <label htmlFor="jsonFileInput" className="file-input-label">
                            {file ? file.name : 'Choose JSON File'}
                        </label>

                        <p className="file-help">Upload JSON file with call log data</p>
                    </div>


                    <div className="sample-data">
                        <h3>Sample JSON Format</h3>
                        <pre>
              {JSON.stringify([
                  {
                      "callId": "1631222399559",
                      "callerName": "John Doe",
                      "phNumber": "0012345678",
                      "callDayTime": "10 Sep 2021 01:19 AM",
                      "callDateInMilliSeconds": "10 Sep 2021 01:19:59",
                      "callDurationInMilliSeconds": "0",
                      "dir": "Outgoing",
                      "callDuration": "0s",
                      "subscription": "",
                      "callLogsUniqueID": "3",
                      "simName": "",
                      "geoLocation": "geoLocation"
                  }
              ], null, 2)}
            </pre>
                    </div>

                    <button
                        type="submit"
                        disabled={uploading || !file}
                        className="upload-btn"
                    >
                        {uploading ? 'Uploading...' : 'Upload Call Logs'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default UploadLogs;